// extracted by mini-css-extract-plugin
export var aboveInput = "_l8-0";
export var actionButton = "_l8-5";
export var actionButtonContainer = "_l8-1";
export var actionIcon = "_l8-6";
export var aiInfoContainer = "_l8-2";
export var attachmentWrapper = "_l8-7";
export var bold = "_l8-3";
export var checkIcon = "_l8-8";
export var clickingRecipientBar = "_l8-11";
export var commentThreadSwitch = "_l8-a";
export var draftImage = "_l8-b";
export var draftImageContainer = "_l8-c";
export var draftImages = "_l8-e";
export var editButton = "_l8-g";
export var editor = "_l8-f";
export var editorContainer = "_l8-y";
export var editorErrorTooltipWrapper = "_l8-9";
export var headerDivider = "_l8-h";
export var icon = "_l8-i";
export var info = "_l8-j";
export var internal = "_l8-n";
export var internalDivider = "_l8-k";
export var internalMessage = "_l8-l";
export var messageInputCard = "_l8-m";
export var messageInputForm = "_l8-o";
export var messageInputFormInternal = "_l8-p";
export var options = "_l8-q";
export var publicMessageCustomer = "_l8-s";
export var publicMessageMerchant = "_l8-r";
export var removeImageButton = "_l8-d";
export var replyButtons = "_l8-t";
export var showSignatureButton = "_l8-u";
export var spinner = "_l8-v";
export var verticalButtonDivider = "_l8-4";
export var visibilitySelector = "_l8-w";
export var warning = "_l8-x";
export var wrappingText = "_l8-z";
export var writingInternalNoteTopBorder = "_l8-10";